import { CtaBlock } from '@components/cta-block'
import { GetInTouch } from '@components/get-in-touch'
import { useGetInTouchContext } from '@components/get-in-touch/Context'
import { Page } from '@components/page'
import { Seo } from '@components/Seo'
import { BeforeAfter } from '@components/_how-it-works/before-after'
import { CloserLook } from '@components/_how-it-works/closer-look'
import { Enhancing } from '@components/_how-it-works/enhancing'
import { Intro } from '@components/_how-it-works/intro'
import { TechnicalSpecs } from '@components/_how-it-works/technical-specs'
import { getSanityClient } from '@lib/sanity/client'
import { useViewportScroll } from 'framer-motion'
import { GetStaticProps } from 'next'
import React, { FC } from 'react'
import { HowItWorksSingleton } from '__generated__/sanity'

type HowItWorksProps = {
  pageContent: HowItWorksSingleton
}

const HowItWorks: FC<HowItWorksProps> = ({ pageContent }) => {
  const { isVisible, open } = useGetInTouchContext()
  const { scrollY } = useViewportScroll()

  return (
    <Page>
      <Seo data={pageContent.fields.seo} />
      {isVisible && <GetInTouch />}
      <Intro {...pageContent.fields.hero} scrollY={scrollY} />
      <CloserLook {...pageContent.fields.closerLook} scrollY={scrollY} />
      <Enhancing {...pageContent.fields.enhancing} scrollY={scrollY} />
      <BeforeAfter {...pageContent.fields.comparing} />
      <TechnicalSpecs {...pageContent.fields.technicalSpecs} />
      <CtaBlock
        variant="margin"
        title={pageContent.fields.ctaFooter.ctaTitle}
        button={pageContent.fields.ctaFooter.ctaButton}
        handleClick={open}
      />
    </Page>
  )
}

export const getStaticProps: GetStaticProps<HowItWorksProps> = async ({ preview = false }) => {
  const sanity = getSanityClient(preview)
  const query = `*[_type == "how-it-works-singleton"]`
  const queryResult = await sanity.fetch(query)
  const draft = queryResult.find((item) => item._id.startsWith('drafts.'))
  const content = preview ? draft || queryResult[0] : queryResult[0]

  return {
    props: {
      pageContent: content as HowItWorksSingleton,
    },
  }
}

export default HowItWorks
